export default __webpack_public_path__ + "static/media/laval.da04492e.jpg";